import { useEffect, useState } from 'react';
import { useScrollProgress, mapRange } from '../heroSignals';

export default function Subtitle() {
  const [mounted, setMounted] = useState(false);
  const scroll = useScrollProgress();

  useEffect(() => {
    const raf = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  // Stage 1 fade
  const fadeT = mapRange(scroll, 0.10, 0.20);
  const opacity = 1 - fadeT;
  const blurPx = fadeT * 10;

  return (
    <div
      className="absolute z-10 pointer-events-none"
      style={{
        left: '6vw',
        bottom: '18vh',
        fontFamily:
          'Inter, "Helvetica Neue", Helvetica, Arial, system-ui, sans-serif',
        opacity,
        filter: blurPx > 0.01 ? `blur(${blurPx}px)` : undefined,
        transition: 'opacity 120ms linear, filter 120ms linear',
        willChange: 'opacity, filter',
      }}
    >
      <div className="overflow-hidden" style={{ padding: '0.1em 0.02em' }}>
        <span
          className="inline-block"
          style={{
            color: 'rgba(255,255,255,0.72)',
            fontSize: '18px',
            fontWeight: 400,
            letterSpacing: '0.02em',
            transform: mounted ? 'translateY(0%)' : 'translateY(110%)',
            transition:
              'transform 1000ms cubic-bezier(0.22,1,0.36,1) 620ms',
          }}
        >
          Precision-engineered sound, reimagined.
        </span>
      </div>
    </div>
  );
}